import React, { useEffect, useState, useRef, lazy } from 'react';
import { TestimonialCard } from './TestimonialCard';
import { CTAButton } from './CTAButton';
import { StickyCTA } from './StickyCTA';
import { EyeIcon, CheckCircle, AlertCircle, ImageIcon } from 'lucide-react';
export const Advertorial = () => {
  const [isScrolledPastFirstTwoSections, setIsScrolledPastFirstTwoSections] = useState(false);
  const [isAtTopSection, setIsAtTopSection] = useState(true);
  const [userCity, setUserCity] = useState('New York');
  const firstTwoSectionsRef = useRef(null);
  // Fetch user location data
  useEffect(() => {
    const fetchUserLocation = async () => {
      try {
        const response = await fetch('https://ipinfo.io/json');
        if (response.ok) {
          const data = await response.json();
          if (data.city && data.city.trim() !== '') {
            setUserCity(data.city);
            console.log(`User location detected: ${data.city}`);
          }
        }
      } catch (error) {
        console.error('Error fetching location data:', error);
      }
    };
    fetchUserLocation();
  }, []);
  useEffect(() => {
    // Set initial states
    setIsScrolledPastFirstTwoSections(false);
    setIsAtTopSection(true);
    const scrollOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -90% 0px'
    };
    const topSectionOptions = {
      threshold: 0.3,
      rootMargin: '-100px 0px 0px 0px'
    };
    const scrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          setIsScrolledPastFirstTwoSections(true);
        } else {
          setIsScrolledPastFirstTwoSections(false);
        }
      });
    }, scrollOptions);
    const topSectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsAtTopSection(true);
        } else {
          setIsAtTopSection(false);
        }
      });
    }, topSectionOptions);
    setTimeout(() => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.observe(firstTwoSectionsRef.current);
        topSectionObserver.observe(firstTwoSectionsRef.current);
      }
    }, 100);
    return () => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.unobserve(firstTwoSectionsRef.current);
        topSectionObserver.unobserve(firstTwoSectionsRef.current);
      }
    };
  }, []);
  useEffect(() => {
    console.log('Scrolled past first two sections:', isScrolledPastFirstTwoSections, 'At top section:', isAtTopSection);
  }, [isScrolledPastFirstTwoSections, isAtTopSection]);
  return <div className="w-full bg-white" data-id="element-7">
      {/* Top Header Bar */}
      <div className="w-full bg-gray-900 text-white" data-id="element-8">
        <div className="container mx-auto px-4 py-2 flex justify-between items-center" data-id="element-9">
          <div className="flex items-center" data-id="element-10">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2" data-id="element-11">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="white" data-id="element-12" />
            </svg>
            <span className="font-semibold tracking-wider" data-id="element-13">WOMEN'S HEALTH</span>
          </div>
          <div className="flex items-center" data-id="element-14">
            <div className="w-5 h-5 mr-2 rounded-full overflow-hidden" data-id="element-15">
              <svg viewBox="0 0 512 512" className="w-full h-full" data-id="element-16">
                <path fill="#f0f0f0" d="M0 85.331h512v341.337H0z" data-id="element-17" />
                <path fill="#d80027" d="M0 85.331h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0z" data-id="element-18" />
                <path fill="#2e52b2" d="M0 85.331h256v183.797H0z" data-id="element-19" />
                <path fill="#f0f0f0" d="M99.822 160.624L95.699 173.308H82.363L93.113 181.143L89.021 193.826L99.822 186.034L110.624 193.826L106.532 181.143L117.306 173.308H103.97z" data-id="element-20" />
                <path fill="#f0f0f0" d="M103.622 219.081l-3.284 10.134h-10.638l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333h-10.638zM167.737 160.624l-4.123 12.684h-13.336l10.75 7.835-4.092 12.683 10.801-7.792 10.802 7.792-4.092-12.683 10.774-7.835h-13.336zM167.737 219.081l-3.284 10.134h-10.638l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333h-10.638zM31.908 160.624l-4.123 12.684H14.449l10.75 7.835-4.092 12.683 10.801-7.792 10.802 7.792-4.092-12.683 10.774-7.835H36.031zM31.908 219.081l-3.284 10.134H17.986l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333H35.192z" data-id="element-21" />
              </svg>
            </div>
            <span className="text-sm" data-id="element-22">Trending in the US</span>
          </div>
        </div>
      </div>

      {/* Header */}
      <header className="w-full border-b border-gray-200" data-id="element-23">
        <div className="container mx-auto px-4 py-3" data-id="element-24">
          <p className="text-xs font-semibold text-gray-500 tracking-wider" data-id="element-25">
            WOMEN'S HEALTH | Advertorial
          </p>
        </div>
      </header>

      {/* Notification Banner */}
      <div className="w-full bg-amber-50 border border-amber-200" data-id="element-26">
        <div className="container mx-auto px-4 py-3 flex items-center justify-center text-center" data-id="element-27">
          <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={20} data-id="element-28" />
          <p className="font-bold text-sm sm:text-base" data-id="element-29">
            UPDATE: Elivara Compression Leggings Are Selling Out FAST! Grab
            Yours NOW to get up to 40% OFF + Fast FREE Shipping Across the US
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4" data-id="element-30">
        <div className="flex flex-col lg:flex-row lg:justify-center" data-id="element-31">
          {/* Main Content */}
          <main className="w-full max-w-3xl mx-auto" data-id="element-32">
            <div className="py-6 px-0 md:px-4" data-id="element-33">
              {/* Headline */}
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4" data-id="element-34">
                You Beat Cancer. So Why Do Your Legs Still Hurt, Bruise, and
                Feel Like They're Getting Worse Every Year?
              </h1>

              {/* Subheadline */}
              <p className="text-lg md:text-xl text-gray-600 mb-6" data-id="element-35">
                What doctors don't tell breast cancer survivors about the
                painful condition that compression garments can't fix alone
              </p>

              {/* Author and Date */}
              <div className="flex items-center justify-between border-b border-gray-200 pb-4 mb-6" data-id="element-36">
                <div className="flex items-center" data-id="element-37">
                  <p className="text-sm text-gray-700" data-id="element-38">
                    By Women's Health Daily | Health & Wellness
                  </p>
                </div>
                <div className="flex items-center text-sm text-gray-500" data-id="element-39">
                  <EyeIcon size={16} className="mr-1" data-id="element-40" />
                  <span data-id="element-41">312,847</span>
                </div>
              </div>

              {/* Featured Image */}
              <div className="mb-8 rounded-lg overflow-hidden" data-id="element-42">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hb7663489Vj6W5fHFmd7JR/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_21_%CF%80.%CE%BC..png" alt="Cancer survivor looking at her legs with concern" className="w-full h-auto" data-id="element-43" />
              </div>

              {/* Opening Section */}
              <div className="mb-10" data-id="element-44">
                <p className="mb-4" data-id="element-45">
                  Sarah Miller thought surviving breast cancer was the hardest
                  thing she'd ever do.
                </p>
                <p className="mb-4" data-id="element-46">She was wrong.</p>
                <p className="mb-4" data-id="element-47">
                  Three years after her last chemo treatment, Sarah was
                  cancer-free. She should have been celebrating. She should have
                  been living her best life.
                </p>
                <p className="mb-4" data-id="element-48">
                  Instead, she was in pain every single day.
                </p>
                <p className="mb-4" data-id="element-49">
                  Her legs felt heavy. Like she was dragging weights around.
                  They swelled up by afternoon and hurt so badly she could
                  barely walk. Even a light bump left giant bruises that took
                  weeks to heal.
                </p>
                <p className="mb-4" data-id="element-50">
                  Her doctor told her it was lymphedema. A common side effect
                  after cancer treatment. He gave her compression garments to
                  wear and said, "This is just something you'll have to manage."
                </p>
                <p className="mb-4" data-id="element-51">
                  But the compression didn't fix it. Her legs kept getting
                  worse. The pain got sharper. The swelling got bigger. The
                  bruising got easier.
                </p>
                <p className="mb-4" data-id="element-52">Sarah felt betrayed by her own body.</p>
                <p className="mb-4" data-id="element-53">
                  "I fought so hard to survive," she told us. "I did everything
                  right. So why am I still suffering?"
                </p>
                <p className="mb-4" data-id="element-54">
                  Doctors dismissed her concerns. They said it was weight gain.
                  They said it was part of recovery. They said she just needed
                  to accept it.
                </p>
                <p className="mb-4" data-id="element-55">But Sarah knew something else was wrong.</p>
                <p className="mb-4 font-semibold" data-id="element-56">And she was right.</p>
              </div>

              {/* If This Sounds Familiar Section */}
              <div className="mb-10" ref={firstTwoSectionsRef} data-id="element-57">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-58">
                  If This Sounds Familiar, You're Not Alone
                </h2>

                <p className="mb-4" data-id="element-59">
                  Thousands of breast cancer survivors are dealing with the same
                  painful symptoms.
                </p>
                <p className="mb-4" data-id="element-60">
                  Legs that feel swollen, heavy, and disproportionate to the
                  rest of your body.
                </p>
                <p className="mb-4" data-id="element-61">
                  Arms that ache and bruise from the lightest touch.
                </p>
                <p className="mb-4" data-id="element-62">
                  Compression garments that help a little but don't actually fix
                  the problem.
                </p>
                <p className="mb-4" data-id="element-63">
                  Doctors who don't seem to understand what you're going
                  through.
                </p>
                <p className="mb-4" data-id="element-64">
                  You beat cancer. You survived the hardest fight of your life.
                  You should be healthy now.
                </p>
                <p className="mb-4" data-id="element-65">But instead, you're dealing with:</p>

                <div className="bg-gray-50 p-4 rounded-md mb-6 space-y-2" data-id="element-66">
                  <p data-id="element-67">
                    <strong data-id="element-68">Constant physical pain.</strong> Your legs hurt when
                    you stand. They hurt when you walk. They hurt when you're
                    just trying to sleep at night.
                  </p>
                  <p data-id="element-69">
                    <strong data-id="element-70">Bruises everywhere.</strong> Even a gentle bump
                    leaves a mark. Your legs look like you've been in an
                    accident.
                  </p>
                  <p data-id="element-71">
                    <strong data-id="element-72">Clothes that don't fit.</strong> Your legs don't
                    match the rest of your body. Nothing looks right anymore.
                  </p>
                  <p data-id="element-73">
                    <strong data-id="element-74">Doctors who dismiss you.</strong> They tell you it's
                    lymphedema. Or weight gain. Or "just part of recovery." They
                    don't listen when you say it's getting worse.
                  </p>
                  <p data-id="element-75">
                    <strong data-id="element-76">Exhaustion from trying everything.</strong> You've
                    worn compression garments for years. You've tried massage
                    therapy. You've changed your diet. Nothing actually fixes
                    it.
                  </p>
                </div>

                <p className="mb-4" data-id="element-77">And worst of all?</p>
                <p className="mb-4" data-id="element-78">
                  You feel alone. Like no one understands what you're going
                  through. Like your body betrayed you after everything you've
                  been through.
                </p>
                <p className="mb-4 font-semibold" data-id="element-79">
                  You fought cancer and won. But you're still losing the battle
                  with your own body.
                </p>
              </div>

              {/* Image 1: Emotional Connection */}
              <div className="mb-10" data-id="element-80">
                <div className="rounded-lg overflow-hidden" data-id="element-81">
                  <img src="https://cdn.magicpatterns.com/uploads/25MQZTLK6hzKEm9tPc5K25/ChatGPT_Image_9_Δεκ_2025,_05_31_19_μ.μ..png" alt="Cancer survivor sitting on bed looking at her swollen legs with concern" className="w-full h-auto" data-id="element-82" />
                </div>
              </div>

              {/* What Doctors Don't Tell Section */}
              <div className="mb-10" data-id="element-83">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-84">
                  Here's What Most Doctors Don't Tell Cancer Survivors
                </h2>

                <p className="mb-4" data-id="element-85">
                  There's a reason your symptoms aren't getting better.
                </p>
                <p className="mb-4" data-id="element-86">
                  And it has nothing to do with weight gain or "just accepting"
                  your new normal.
                </p>
                <p className="mb-4 font-semibold" data-id="element-87">
                  The problem is this: Most doctors are missing a critical
                  diagnosis.
                </p>
                <p className="mb-4" data-id="element-88">
                  They're treating you for lymphedema when you might actually
                  have something else entirely.
                </p>
                <p className="mb-4" data-id="element-89">Let me explain.</p>
                <p className="mb-4" data-id="element-90">
                  Lymphedema is what most cancer survivors know about. It
                  happens when your lymphatic system gets damaged during cancer
                  treatment. Fluid builds up in your tissues. Your legs or arms
                  swell.
                </p>
                <p className="mb-4" data-id="element-91">
                  Traditional treatments for lymphedema include:
                </p>

                <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-92">
                  <li data-id="element-93">Compression garments</li>
                  <li data-id="element-94">Manual lymphatic drainage massage</li>
                  <li data-id="element-95">Elevation</li>
                  <li data-id="element-96">Exercise</li>
                </ul>

                <p className="mb-4" data-id="element-97">
                  And for true lymphedema, these treatments can help.
                </p>
                <p className="mb-4" data-id="element-98">But here's the problem.</p>
                <p className="mb-4 font-semibold" data-id="element-99">
                  Thousands of cancer survivors don't actually have lymphedema.
                </p>
                <p className="mb-4" data-id="element-100">They have something called lipedema.</p>
                <p className="mb-4" data-id="element-101">
                  Lipedema is completely different. It's not fluid buildup. It's
                  a fat cell disorder that causes painful, diseased fat tissue
                  to grow in your legs and arms.
                </p>
                <p className="mb-4" data-id="element-102">
                  The tissue is inflamed. It bruises easily. It hurts
                  constantly. And it gets progressively worse over time.
                </p>
                <p className="mb-4 font-semibold" data-id="element-103">
                  Here's the kicker: Lipedema looks almost exactly like
                  lymphedema to most doctors.
                </p>
                <p className="mb-4" data-id="element-104">
                  Both cause swelling. Both happen in the legs or arms. Both are
                  common after cancer treatment.
                </p>
                <p className="mb-4" data-id="element-105">But they need different approaches.</p>
                <p className="mb-4 font-semibold" data-id="element-106">
                  And that's why compression garments alone don't fix it.
                </p>
              </div>

              {/* Image 2: Lymphedema vs Lipedema Comparison */}
              <div className="mb-10" data-id="element-107">
                <div className="bg-blue-50 p-6 rounded-lg" data-id="element-108">
                  <h3 className="text-lg font-bold text-center mb-4 text-gray-800" data-id="element-109">
                    Understanding the Difference: Lymphedema vs. Lipedema
                  </h3>
                  <img src="https://cdn.magicpatterns.com/uploads/2DYRbfzY3Pqw89SNuGeA9b/ChatGPT_Image_9_Δεκ_2025,_05_31_17_μ.μ..png" alt="Medical illustration comparing lymphedema fluid buildup versus lipedema diseased fat cells and inflammation" className="w-full h-auto rounded-lg" data-id="element-110" />
                  <p className="text-sm text-gray-600 text-center mt-4" data-id="element-111">
                    Lymphedema is fluid buildup in tissues. Lipedema is
                    diseased, inflamed fat cells that press on lymphatic
                    vessels—requiring a different approach.
                  </p>
                </div>
              </div>

              {/* How Do You Know Section */}
              <div className="mb-10" data-id="element-112">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-113">
                  How Do You Know If It's Really Lipedema?
                </h2>

                <p className="mb-4" data-id="element-114">Ask yourself these questions:</p>

                <div className="bg-blue-50 p-6 rounded-md mb-6 space-y-3" data-id="element-115">
                  <p data-id="element-116">
                    ✓ Have you been wearing compression garments for years, but
                    your symptoms keep getting worse?
                  </p>
                  <p data-id="element-117">
                    ✓ Do you bruise incredibly easily, even from light pressure?
                  </p>
                  <p data-id="element-118">
                    ✓ Is your swelling symmetrical (both legs or both arms
                    equally affected)?
                  </p>
                  <p data-id="element-119">
                    ✓ Does the swelling stop at your ankles or wrists (leaving
                    your feet and hands normal)?
                  </p>
                  <p data-id="element-120">
                    ✓ Have you tried diet and exercise, but the fat in your legs
                    won't budge?
                  </p>
                  <p data-id="element-121">
                    ✓ Did manual lymphatic drainage massage give you only
                    temporary relief?
                  </p>
                  <p data-id="element-122">
                    ✓ Has your doctor dismissed your pain or told you "it's just
                    weight gain"?
                  </p>
                </div>

                <p className="mb-4 font-semibold" data-id="element-123">
                  If you answered yes to three or more of these, you might have
                  lipedema, not lymphedema.
                </p>
                <p className="mb-4" data-id="element-124">And here's why that matters:</p>
                <p className="mb-4 font-semibold" data-id="element-125">
                  Lipedema needs more than just compression.
                </p>
                <p className="mb-4" data-id="element-126">
                  You need targeted support for both your lymphatic system AND
                  the inflamed fat tissue causing your pain.
                </p>
                <p className="mb-4 font-semibold" data-id="element-127">
                  That's exactly what cancer survivors are discovering actually
                  helps.
                </p>
              </div>

              {/* What Cancer Survivors Are Using Section */}
              <div className="mb-10" data-id="element-128">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-129">
                  What Cancer Survivors With Lipedema Are Using That's Actually
                  Helping
                </h2>

                <p className="mb-4" data-id="element-130">
                  After years of failed treatments and dismissive doctors,
                  cancer survivors started talking to each other.
                </p>
                <p className="mb-4" data-id="element-131">
                  In support groups. In online forums. In Facebook communities.
                </p>
                <p className="mb-4" data-id="element-132">
                  They shared what was actually working. What actually reduced
                  their pain. What actually let them live their lives again.
                </p>
                <p className="mb-4 font-semibold" data-id="element-133">
                  And the same solution kept coming up again and again.
                </p>
                <p className="mb-4 font-semibold" data-id="element-134">
                  Elivara Compression Leggings with FlowMapping™ Technology.
                </p>

                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-135">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qXr4YxNDa3ZLDxwoFvkcy4/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_34_%CF%80.%CE%BC..png" alt="Elivara compression leggings showing FlowMapping technology" className="w-full h-auto" data-id="element-136" />
                </div>

                <p className="mb-4" data-id="element-137">
                  These aren't your typical compression garments.
                </p>
                <p className="mb-4" data-id="element-138">
                  Yes, they provide medical-grade compression. But they do
                  something regular compression can't do alone.
                </p>
                <p className="mb-4 font-semibold" data-id="element-139">
                  They support your lymphatic system while targeting
                  lipedema-specific inflammation.
                </p>
                <p className="mb-4" data-id="element-140">Here's how it works:</p>
                <p className="mb-4" data-id="element-141">
                  Traditional compression garments squeeze your legs to reduce
                  fluid buildup. That's it. They help with lymphedema, but they
                  don't address diseased fat tissue. They don't reduce
                  inflammation. They don't stop the bruising or the pain.
                </p>
                <p className="mb-4 font-semibold" data-id="element-142">
                  Elivara leggings with FlowMapping™ do three things at once:
                </p>

                <div className="space-y-4 mb-6" data-id="element-143">
                  <div className="bg-green-50 p-4 rounded-md" data-id="element-144">
                    <p className="font-semibold mb-2" data-id="element-145">
                      1. Graduated compression
                    </p>
                    <p data-id="element-146">
                      (tightest at the ankle, gradually lighter moving up) to
                      support your lymphatic system and reduce fluid buildup.
                    </p>
                  </div>

                  <div className="bg-green-50 p-4 rounded-md" data-id="element-147">
                    <p className="font-semibold mb-2" data-id="element-148">
                      2. Integrated lymphatic support channels
                    </p>
                    <p data-id="element-149">
                      that encourage natural drainage along the pathways your
                      body is supposed to use.
                    </p>
                  </div>

                  <div className="bg-green-50 p-4 rounded-md" data-id="element-150">
                    <p className="font-semibold mb-2" data-id="element-151">
                      3. Targeted pressure zones
                    </p>
                    <p data-id="element-152">
                      designed specifically for lipedema to reduce inflammation
                      in the fat tissue itself.
                    </p>
                  </div>
                </div>

                <p className="mb-4" data-id="element-153">Think of it like this:</p>
                <p className="mb-4" data-id="element-154">
                  Regular compression is like putting a band-aid on a deep cut.
                  It might help a little, but it doesn't actually heal the
                  problem.
                </p>
                <p className="mb-4" data-id="element-155">
                  Elivara's FlowMapping™ Technology is like having a team of
                  therapists working on your legs all day long. Supporting your
                  lymphatic system. Reducing inflammation. Targeting the root
                  cause.
                </p>
                <p className="mb-4 font-semibold" data-id="element-156">
                  And for cancer survivors with lipedema, that makes all the
                  difference.
                </p>
              </div>

              {/* Image 3: FlowMapping Technology Visualization */}
              <div className="mb-10" data-id="element-157">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-158">
                  <h3 className="text-lg font-bold text-center mb-4 text-gray-800" data-id="element-159">
                    How FlowMapping™ Technology Works
                  </h3>
                  <img src="https://cdn.magicpatterns.com/uploads/iS5E4cc9m8RtHWtqiBMuLY/ChatGPT_Image_9_Δεκ_2025,_05_31_16_μ.μ..png" alt="Elivara leggings showing graduated compression, lymphatic support channels, and targeted pressure zones" className="w-full h-auto rounded-lg" data-id="element-160" />
                  <p className="text-sm text-gray-600 text-center mt-4" data-id="element-161">
                    Three integrated technologies working together: graduated
                    compression, lymphatic support channels following natural
                    drainage pathways, and targeted pressure zones for
                    inflammation.
                  </p>
                </div>
              </div>

              {/* Visual Explanation of FlowMapping™ Technology */}
              <div className="mb-10" data-id="element-162">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-163">
                  See the FlowMapping™ Difference
                </h2>
                <div className="mb-6 rounded-lg overflow-hidden bg-blue-50 p-4" data-id="element-164">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4ge5gzuHf48wNS9HaJaGCz/gempages_541671622348637232-7a3a123c-f1c8-4b25-b1a4-f051e570e74b.webp" alt="Animation showing the difference between painful lipedema fluid buildup and FlowMapping technology" className="w-full h-auto mx-auto" data-id="element-165" />
                  <div className="flex justify-between mt-4 text-sm md:text-base" data-id="element-166">
                    <div className="text-center w-1/2 border-r border-blue-200 pr-2" data-id="element-167">
                      <p className="font-bold text-red-500 mb-1" data-id="element-168">
                        WITHOUT SUPPORT
                      </p>
                      <p className="text-gray-700" data-id="element-169">
                        Painful fluid buildup and inflammation
                      </p>
                    </div>
                    <div className="text-center w-1/2 pl-2" data-id="element-170">
                      <p className="font-bold text-green-500 mb-1" data-id="element-171">
                        WITH FLOWMAPPING™
                      </p>
                      <p className="text-gray-700" data-id="element-172">
                        Guided fluid drainage along natural pathways
                      </p>
                    </div>
                  </div>
                </div>
                <p className="mb-4" data-id="element-173">
                  This visual perfectly captures what makes FlowMapping™
                  technology so revolutionary. On the left, you can see what
                  happens in lipedema-affected legs: fluid builds up (shown in
                  red), creating painful inflammation and swelling that doesn't
                  respond to diet or exercise.
                </p>
                <p className="mb-4" data-id="element-174">
                  On the right, you see how Elivara's patented FlowMapping™
                  technology works. The strategically placed compression zones
                  (shown as green chevrons) create directional pressure that
                  guides trapped fluid along your natural lymphatic pathways.
                  This helps your body drain the fluid properly, reducing
                  swelling, pain, and that heavy feeling that comes with
                  lipedema.
                </p>
              </div>

              {/* Real Cancer Survivors Section */}
              <div className="mb-10" data-id="element-175">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-176">
                  Real Cancer Survivors, Real Results
                </h2>

                <div className="space-y-6 mb-6" data-id="element-177">
                  <TestimonialCard quote="I had breast cancer in 2019. Three years later, my legs were still swollen and painful. My doctor said it was lymphedema, but the compression stockings barely helped. I found Elivara through a cancer support group. After just four weeks, the constant bruising stopped. The pain is 70% better. I can walk my dog again without limping. I can play with my grandkids. I honestly didn't think I'd ever feel normal again." author="Jennifer M." age="58" location="Illinois" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/eb9DbMXxnEv4xRdj6M31AN/Beth_-_living_with_lipedema.webp" data-id="element-178" />

                  <TestimonialCard quote="After my double mastectomy, my legs kept getting bigger and more painful. Every doctor told me to lose weight. But I knew it was something else. I tried Elivara and within two months, the swelling went down so much I could finally wear jeans again. The sharp pains are gone. I can stand at work without agony. This changed my life." author="Rachel T." age="44" location="Texas" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/3y7To7DiABw2UivqWYkvYv/images_%2842%29.jpg" data-id="element-179" />

                  <TestimonialCard quote="I've been cancer-free for six years, but my legs have been getting worse the whole time. I spent thousands on compression garments that were so uncomfortable I could barely wear them. Elivara is the first thing that actually works AND feels good enough to wear all day. The bruising is almost gone. My legs don't feel like dead weight anymore. I'm honestly angry I suffered for so long when this solution existed." author="Maria S." age="62" location="Florida" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/1ZzQbxP1337U3TnJrDfMSW/istockphoto-1290775513-612x612.jpg" data-id="element-180" />

                  <TestimonialCard quote="When I told my oncologist my legs hurt constantly and compression wasn't helping, she said it was normal after cancer treatment. I tried Elivara anyway. Eight weeks later, my legs looked visibly smaller and the pain was 80% gone. At my next appointment, even my doctor was shocked. She asked what I was doing differently. Now she's recommending them to other patients." author="Linda K." age="51" location="California" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/jA5TbK1HAopveddK7FXfLL/mockup-pretty-curvy-latin-woman-600nw-2460705183.webp" data-id="element-181" />
                </div>
              </div>

              {/* Why FlowMapping Works Section */}
              <div className="mb-10" data-id="element-182">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-183">
                  Why FlowMapping™ Technology Works When Compression Alone
                  Doesn't
                </h2>

                <p className="mb-4" data-id="element-184">
                  Your body has an entire network of lymphatic vessels. Think of
                  them like highways for fluid to drain naturally.
                </p>
                <p className="mb-4" data-id="element-185">
                  When you have cancer treatment, some of those highways get
                  damaged. Fluid can't drain properly. It builds up.
                </p>
                <p className="mb-4" data-id="element-186">That's lymphedema.</p>
                <p className="mb-4" data-id="element-187">
                  But with lipedema, you have a second problem. The fat cells
                  themselves are diseased. They're inflamed. They leak fluid
                  into surrounding tissue. They press on your lymphatic vessels
                  and make drainage even harder.
                </p>
                <p className="mb-4 font-semibold" data-id="element-188">So you need two things:</p>

                <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-189">
                  <li data-id="element-190">
                    Support for your damaged lymphatic system (like compression
                    provides)
                  </li>
                  <li data-id="element-191">
                    Targeted pressure to reduce inflammation in the fat tissue
                    itself (which regular compression doesn't do)
                  </li>
                </ul>

                <p className="mb-4 font-semibold" data-id="element-192">
                  That's exactly what FlowMapping™ Technology does.
                </p>
                <p className="mb-4" data-id="element-193">
                  The graduated compression supports your lymphatic drainage.
                  Tightest at the ankle where fluid tends to pool most.
                  Gradually lighter as it moves up your leg.
                </p>
                <p className="mb-4" data-id="element-194">
                  But the real breakthrough is the integrated support channels.
                </p>
                <p className="mb-4" data-id="element-195">
                  These channels follow your body's natural lymphatic pathways.
                  They create gentle, consistent pressure that encourages fluid
                  to move in the right direction. Up and out of your legs. Back
                  into circulation where it belongs.
                </p>
                <p className="mb-4" data-id="element-196">
                  At the same time, targeted pressure zones reduce inflammation
                  in the lipedema tissue itself. Less inflammation means less
                  pain. Less bruising. Less swelling.
                </p>
                <p className="mb-4 font-semibold" data-id="element-197">
                  It's comprehensive support in one garment.
                </p>
                <p className="mb-4" data-id="element-198">
                  And because Elivara leggings are made with breathable,
                  medical-grade fabric, you can actually wear them all day
                  comfortably.
                </p>
                <p className="mb-4" data-id="element-199">
                  Not like those thick, suffocating compression stockings that
                  hurt to put on and make you sweat.
                </p>
                <p className="mb-4" data-id="element-200">
                  These feel like regular leggings. Soft. Breathable.
                  Comfortable enough to wear under your clothes.
                </p>
                <p className="mb-4 font-semibold" data-id="element-201">
                  But they're working the entire time you're wearing them.
                </p>
              </div>

              {/* Why Not Regular Compression Section */}
              <div className="mb-10" data-id="element-202">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-203">
                  "Why Not Just Use Regular Compression Garments?"
                </h2>

                <p className="mb-4" data-id="element-204">We get this question a lot.</p>
                <p className="mb-4" data-id="element-205">
                  And it's a fair one. If you've been wearing compression
                  stockings for years, why switch?
                </p>
                <p className="mb-4" data-id="element-206">Here's the honest answer:</p>
                <p className="mb-4" data-id="element-207">
                  Regular compression garments are better than nothing. They
                  provide some support. They can reduce fluid buildup
                  temporarily.
                </p>
                <p className="mb-4 font-semibold" data-id="element-208">
                  But they have major limitations:
                </p>

                <div className="space-y-4 mb-6" data-id="element-209">
                  <div className="bg-gray-50 p-4 rounded-md" data-id="element-210">
                    <p className="font-semibold mb-2" data-id="element-211">They're uncomfortable.</p>
                    <p data-id="element-212">
                      Most cancer survivors tell us they dread putting them on.
                      They're tight, hot, and restrictive. Many women can't wear
                      them for more than a few hours before they become
                      unbearable.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-4 rounded-md" data-id="element-213">
                    <p className="font-semibold mb-2" data-id="element-214">
                      They're expensive over time.
                    </p>
                    <p data-id="element-215">
                      Medical-grade compression stockings wear out quickly. You
                      need to replace them every 3-6 months. At $100-200 per
                      pair, that adds up to thousands of dollars.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-4 rounded-md" data-id="element-216">
                    <p className="font-semibold mb-2" data-id="element-217">
                      They only address fluid, not inflammation.
                    </p>
                    <p data-id="element-218">
                      Compression helps move fluid, but it doesn't reduce the
                      inflammation in lipedema fat tissue. That's why the pain
                      and bruising continue even with regular compression.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-4 rounded-md" data-id="element-219">
                    <p className="font-semibold mb-2" data-id="element-220">
                      They don't support your lymphatic pathways.
                    </p>
                    <p data-id="element-221">
                      They squeeze uniformly, but they don't guide fluid along
                      the specific routes your body needs for proper drainage.
                    </p>
                  </div>
                </div>

                <p className="mb-4 font-semibold" data-id="element-222">
                  Elivara is different because it was designed specifically for
                  lipedema, not just lymphedema.
                </p>
                <p className="mb-4" data-id="element-223">
                  It provides the compression you need, plus the lymphatic
                  support regular garments don't have, plus targeted
                  anti-inflammatory pressure zones.
                </p>
                <p className="mb-4" data-id="element-224">
                  All in one comfortable garment you can actually wear all day.
                </p>
                <p className="mb-4 italic" data-id="element-225">
                  One woman told us: "I spent five years fighting with
                  compression stockings. They helped a little, but I could never
                  wear them long enough. Elivara is the first thing I've
                  actually been able to stick with. And it's the first thing
                  that's actually worked."
                </p>
              </div>

              {/* What About Liposuction Section */}
              <div className="mb-10" data-id="element-226">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-227">
                  "What About Liposuction?"
                </h2>

                <p className="mb-4" data-id="element-228">
                  Some doctors recommend liposuction for severe lipedema.
                </p>
                <p className="mb-4" data-id="element-229">And in extreme cases, surgery can help.</p>
                <p className="mb-4 font-semibold" data-id="element-230">
                  But here's what they often don't tell you:
                </p>

                <div className="space-y-4 mb-6" data-id="element-231">
                  <div className="bg-red-50 p-4 rounded-md border-l-4 border-red-400" data-id="element-232">
                    <p className="font-semibold mb-2" data-id="element-233">
                      Liposuction for lipedema costs $10,000-$20,000.
                    </p>
                    <p data-id="element-234">
                      And insurance almost never covers it. Most cancer
                      survivors simply can't afford it.
                    </p>
                  </div>

                  <div className="bg-red-50 p-4 rounded-md border-l-4 border-red-400" data-id="element-235">
                    <p className="font-semibold mb-2" data-id="element-236">It's risky.</p>
                    <p data-id="element-237">
                      Any surgery comes with risks. Infection. Complications.
                      Poor results. And for someone who's already been through
                      cancer treatment, more surgery is the last thing you want.
                    </p>
                  </div>

                  <div className="bg-red-50 p-4 rounded-md border-l-4 border-red-400" data-id="element-238">
                    <p className="font-semibold mb-2" data-id="element-239">
                      It requires significant downtime.
                    </p>
                    <p data-id="element-240">
                      You can't work. You can't take care of your family. You
                      need weeks of recovery.
                    </p>
                  </div>

                  <div className="bg-red-50 p-4 rounded-md border-l-4 border-red-400" data-id="element-241">
                    <p className="font-semibold mb-2" data-id="element-242">
                      It doesn't fix the lymphatic dysfunction.
                    </p>
                    <p data-id="element-243">
                      Surgery removes some of the diseased fat tissue, but it
                      doesn't restore your lymphatic system's ability to drain
                      properly. Many women still need compression afterward.
                    </p>
                  </div>

                  <div className="bg-red-50 p-4 rounded-md border-l-4 border-red-400" data-id="element-244">
                    <p className="font-semibold mb-2" data-id="element-245">
                      And the lipedema can come back.
                    </p>
                    <p data-id="element-246">
                      Without ongoing lymphatic support and inflammation
                      management, the tissue can accumulate again over time.
                    </p>
                  </div>
                </div>

                <p className="mb-4 font-semibold" data-id="element-247">
                  Elivara offers a non-invasive alternative that actually
                  addresses the underlying lymphatic dysfunction and
                  inflammation.
                </p>
                <p className="mb-4" data-id="element-248">No surgery. No downtime. No risk.</p>
                <p className="mb-4" data-id="element-249">
                  Just consistent, comfortable support that helps your body
                  function the way it's supposed to.
                </p>
                <p className="mb-4" data-id="element-250">
                  And at a fraction of the cost of surgery.
                </p>
              </div>

              {/* Special Offer Section */}
              <div className="mb-10 bg-gradient-to-r from-green-50 to-blue-50 p-8 rounded-lg border-2 border-green-200" data-id="element-251">
                <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4 text-center" data-id="element-252">
                  Special Offer For Cancer Survivors
                </h2>

                <p className="mb-4 text-center" data-id="element-253">
                  We know cancer survivors have already been through enough.
                </p>
                <p className="mb-4 text-center" data-id="element-254">
                  You've spent thousands on treatment. You've sacrificed your
                  time, your energy, your peace of mind.
                </p>
                <p className="mb-4 text-center font-semibold" data-id="element-255">
                  You shouldn't have to spend thousands more just to feel
                  comfortable in your own body.
                </p>
                <p className="mb-6 text-center" data-id="element-256">
                  That's why we're offering a special discount exclusively for
                  cancer survivors.
                </p>

                <div className="mb-6 bg-white rounded-lg overflow-hidden" data-id="element-257">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/23Hx8bzAVQ7dcDK8zTNUdC/Trusted_by_Women_Across_the_USA.png" alt="Elivara Lipedema Leggings with premium packaging, 30-day money back guarantee, and free shipping" className="w-full h-auto" data-id="element-258" />
                </div>

                <div className="bg-white p-6 rounded-lg shadow-lg mb-6" data-id="element-259">
                  <h3 className="text-xl font-bold text-center mb-4 text-green-600" data-id="element-260">
                    Get 40% off Elivara FlowMapping™ Leggings + Free Shipping
                  </h3>
                  <p className="text-center mb-4" data-id="element-261">
                    Plus, try them completely risk-free for 30 days.
                  </p>
                  <p className="text-center font-semibold" data-id="element-262">
                    If you don't feel less pain, less swelling, and more
                    mobility within 30 days, return them for a full refund. No
                    questions asked.
                  </p>
                </div>

                <p className="text-center text-lg font-semibold mb-4" data-id="element-263">
                  You've already fought the hardest battle of your life. You
                  deserve relief.
                </p>

                <div className="text-center" data-id="element-264">
                  <a href="https://tryelivara.com/pages/elivara-landing-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-lg shadow-md transition-all transform hover:scale-105 inline-block text-lg uppercase tracking-wider" data-id="element-265">
                    Claim Your 40% Cancer Survivor Discount Now →
                  </a>
                </div>
              </div>

              {/* Questions Section */}
              <div className="mb-10" data-id="element-266">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-6" data-id="element-267">
                  Questions Cancer Survivors Ask Us
                </h2>

                <div className="space-y-6" data-id="element-268">
                  <div className="bg-gray-50 p-5 rounded-lg" data-id="element-269">
                    <h3 className="font-bold mb-2" data-id="element-270">
                      "How is this different from the compression garments my
                      doctor prescribed?"
                    </h3>
                    <p data-id="element-271">
                      Your prescribed compression stockings provide uniform
                      pressure to reduce fluid buildup. Elivara does that too,
                      but it also includes FlowMapping™ Technology—integrated
                      lymphatic support channels and targeted pressure zones
                      designed specifically for lipedema. Regular compression
                      only addresses fluid. Elivara addresses fluid AND inflamed
                      fat tissue.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-5 rounded-lg" data-id="element-272">
                    <h3 className="font-bold mb-2" data-id="element-273">
                      "Will this work for Stage 2 or Stage 3 lipedema?"
                    </h3>
                    <p data-id="element-274">
                      Yes. We've had cancer survivors with Stage 2 and Stage 3
                      lipedema report significant pain reduction and swelling
                      improvement. The earlier you start using targeted support,
                      the better your results will be. But even advanced
                      lipedema responds well to proper lymphatic support and
                      anti-inflammatory compression.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-5 rounded-lg" data-id="element-275">
                    <h3 className="font-bold mb-2" data-id="element-276">
                      "What if I have both lymphedema AND lipedema?"
                    </h3>
                    <p data-id="element-277">
                      That's actually very common in cancer survivors. Elivara
                      is designed to address both conditions simultaneously. The
                      graduated compression supports lymphatic drainage
                      (lymphedema), while the targeted pressure zones reduce
                      inflammation in lipedema tissue. Many women with both
                      conditions tell us Elivara is the first thing that's
                      helped both problems at once.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-5 rounded-lg" data-id="element-278">
                    <h3 className="font-bold mb-2" data-id="element-279">
                      "How long until I see results?"
                    </h3>
                    <p data-id="element-280">
                      Most cancer survivors notice less pain and easier movement
                      within the first 1-2 weeks. Visible reduction in swelling
                      typically takes 4-6 weeks of consistent daily wear.
                      Bruising reduction happens gradually over 2-3 months.
                      Everyone's body is different, but consistent wear gives
                      you the best results.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-5 rounded-lg" data-id="element-281">
                    <h3 className="font-bold mb-2" data-id="element-282">
                      "What if they don't fit or don't work for me?"
                    </h3>
                    <p data-id="element-283">
                      That's exactly why we offer a 30-day money-back guarantee.
                      If Elivara doesn't reduce your pain and swelling, return
                      them for a full refund. We also provide a detailed sizing
                      guide to help you find your perfect fit. And our customer
                      service team (many of whom are lipedema patients
                      themselves) can help you troubleshoot any fit issues.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-5 rounded-lg" data-id="element-284">
                    <h3 className="font-bold mb-2" data-id="element-285">
                      "Are these covered by insurance?"
                    </h3>
                    <p data-id="element-286">
                      Currently, most insurance companies don't cover lipedema
                      garments (just like they don't cover liposuction for
                      lipedema). However, Elivara costs less than 3-6 months of
                      replacement compression stockings, and it lasts much
                      longer. Many women use their HSA or FSA funds to purchase.
                      Check with your insurance provider about reimbursement
                      options.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-5 rounded-lg" data-id="element-287">
                    <h3 className="font-bold mb-2" data-id="element-288">
                      "Can I really wear these all day?"
                    </h3>
                    <p data-id="element-289">
                      Yes! That's one of the biggest differences between Elivara
                      and traditional compression garments. The fabric is
                      breathable, moisture-wicking, and soft. Most women tell us
                      they forget they're wearing them. You can wear them under
                      regular clothes, to work, while exercising, even to sleep
                      if you want. The more consistently you wear them, the
                      better your results.
                    </p>
                  </div>
                </div>
              </div>

              {/* Final Section */}
              <div className="mb-10" data-id="element-290">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-291">
                  You've Already Survived the Impossible
                </h2>

                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-292">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fcFTP9s5La88PDr9GNhj1H/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_56_%CF%80.%CE%BC..png" alt="Cancer survivor walking confidently, feeling relief" className="w-full h-auto" data-id="element-293" />
                </div>

                <p className="mb-4" data-id="element-294">You beat cancer.</p>
                <p className="mb-4" data-id="element-295">
                  You endured surgeries, treatments, and side effects most
                  people can't imagine.
                </p>
                <p className="mb-4" data-id="element-296">
                  You fought harder than you ever thought possible.
                </p>
                <p className="mb-4" data-id="element-297">And you won.</p>
                <p className="mb-4 font-semibold" data-id="element-298">
                  You shouldn't have to keep suffering.
                </p>
                <p className="mb-4" data-id="element-299">
                  Not from pain that makes it hard to walk.
                </p>
                <p className="mb-4" data-id="element-300">
                  Not from bruising that makes you self-conscious.
                </p>
                <p className="mb-4" data-id="element-301">
                  Not from doctors who dismiss your concerns.
                </p>
                <p className="mb-4" data-id="element-302">
                  Not from compression garments that barely help.
                </p>
                <p className="mb-4 font-semibold" data-id="element-303">
                  You deserve to feel good in your body again.
                </p>
                <p className="mb-4" data-id="element-304">You deserve to walk without pain.</p>
                <p className="mb-4" data-id="element-305">You deserve to play with your grandkids.</p>
                <p className="mb-4" data-id="element-306">
                  You deserve to travel, to work, to live your life fully.
                </p>
                <p className="mb-4 font-semibold" data-id="element-307">You deserve relief.</p>
                <p className="mb-6" data-id="element-308">
                  Thousands of cancer survivors just like you are finding that
                  relief with Elivara.
                </p>
                <p className="mb-4" data-id="element-309">
                  Women who spent years in pain, trying everything, being
                  dismissed by doctors.
                </p>
                <p className="mb-4" data-id="element-310">
                  Women who thought they'd just have to accept their "new
                  normal."
                </p>
                <p className="mb-4 font-semibold" data-id="element-311">
                  Women who finally found something that actually works.
                </p>
                <p className="mb-6" data-id="element-312">
                  Try Elivara completely risk-free for 30 days.
                </p>
                <p className="mb-4" data-id="element-313">
                  If you don't feel less pain, less swelling, and more freedom
                  to move, return them for a full refund.
                </p>
                <p className="mb-4 font-semibold" data-id="element-314">
                  You have nothing to lose except the pain you've been carrying
                  for too long.
                </p>
                <p className="mb-6 text-xl font-bold" data-id="element-315">
                  You beat cancer. Now it's time to reclaim your life.
                </p>

                <div className="text-center bg-green-50 p-8 rounded-lg border-2 border-green-300" data-id="element-316">
                  <a href="https://tryelivara.com/pages/elivara-landing-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-lg shadow-md transition-all transform hover:scale-105 inline-block text-lg uppercase tracking-wider" data-id="element-317">
                    Get 40% Off + Free Shipping (Cancer Survivor Discount) →
                  </a>
                  <p className="mt-4 text-sm text-gray-600" data-id="element-318">
                    Limited inventory available. This discount is exclusively
                    for cancer survivors and ends soon. Claim your pair while
                    supplies last.
                  </p>
                </div>
              </div>
            </div>
          </main>

          {/* Right-side CTA - Always visible on desktop */}
          <aside className="hidden lg:block lg:w-80 lg:ml-8 lg:flex-shrink-0 mt-6" data-id="element-319">
            <div className="sticky top-6" data-id="element-320">
              <StickyCTA showNewImage={true} data-id="element-321" />
            </div>
          </aside>
        </div>
      </div>

      {/* Sticky CTA - Always visible at the bottom */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 z-50" data-id="element-322">
        <a href="https://tryelivara.com/pages/elivara-landing-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg shadow-md transition-all w-full uppercase tracking-wider text-center block" data-id="element-323">
          DISCOVER ELIVARA & SAVE 40% TODAY →
        </a>
      </div>

      {/* Special Offer Banner */}
      <div className="w-full bg-red-50 border-y border-red-200" data-id="element-324">
        <div className="container mx-auto px-4 py-6" data-id="element-325">
          <div className="flex flex-col sm:flex-row items-center justify-center text-center gap-4" data-id="element-326">
            <div className="flex items-center" data-id="element-327">
              <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={24} data-id="element-328" />
              <p className="font-bold text-lg" data-id="element-329">SPECIAL OFFER:</p>
            </div>
            <p className="font-bold text-red-700 text-lg px-4" data-id="element-330">
              Get Elivara Compression Leggings at 40% OFF + FREE Shipping for a
              Limited Time!
            </p>
            <a href="https://tryelivara.com/pages/elivara-landing-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg text-base whitespace-nowrap inline-block" data-id="element-331">
              CLAIM OFFER
            </a>
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <footer className="w-full bg-gray-100" data-id="element-332">
        <div className="container mx-auto px-4 py-6 max-w-4xl" data-id="element-333">
          <div className="text-xs text-gray-500 pt-6 mb-8" data-id="element-334">
            <p className="mb-2" data-id="element-335">
              This is an advertisement and not an actual news article, blog, or
              consumer protection update. Individual results may vary.
            </p>
            <div className="flex flex-wrap space-x-2 mb-2" data-id="element-336">
              <span data-id="element-337">About Us</span>
              <span data-id="element-338">|</span>
              <span data-id="element-339">Terms of Use</span>
              <span data-id="element-340">|</span>
              <span data-id="element-341">Privacy Policy</span>
            </div>
            <p className="mb-2" data-id="element-342">
              Trademarks utilized on our website belong to their respective
              owners and no implied or expressed endorsement of our website or
              services is intended. Through in-depth research and experienced
              editors we provide feedback about products and services. We are
              independently owned, and opinions expressed here are our own. This
              website is an independent professional comparison and review site
              supported by referral fees from the sites and products featured.
            </p>
            <p data-id="element-343">©2025 Women's Health Insights. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    </div>;
};